import { OrderStage } from '@erp/shared-types';

/**
 * Display labels + canonical ordering for the sales-order approval funnel
 * stages. Single source of truth shared by the Sales Reports page and the
 * draft Activity tab so the two never drift.
 */

export const ORDER_STAGE_ORDER: readonly OrderStage[] = [
  OrderStage.Received,
  OrderStage.AwaitingDiscountApproval,
  OrderStage.AwaitingOrderApproval,
  OrderStage.SubmittedToErp,
  OrderStage.Rejected,
];

export const ORDER_STAGE_LABELS: Record<OrderStage, string> = {
  [OrderStage.Received]: 'Received',
  [OrderStage.AwaitingDiscountApproval]: 'Awaiting discount approval',
  [OrderStage.AwaitingOrderApproval]: 'Awaiting order approval',
  [OrderStage.SubmittedToErp]: 'Submitted to ERP',
  [OrderStage.Rejected]: 'Rejected',
};

export function formatOrderStageLabel(stage: OrderStage | string): string {
  return ORDER_STAGE_LABELS[stage as OrderStage] ?? String(stage);
}

/** Short phrasing for a stage transition shown in the Activity feed. */
export function orderStageActivityDescription(
  stage: OrderStage | string,
): string {
  switch (stage) {
    case OrderStage.Received:
      return 'Order received';
    case OrderStage.AwaitingDiscountApproval:
      return 'Awaiting discount approval';
    case OrderStage.AwaitingOrderApproval:
      return 'Awaiting order approval';
    case OrderStage.SubmittedToErp:
      return 'Submitted to ERP';
    case OrderStage.Rejected:
      return 'Order rejected';
    default:
      return `Stage changed to ${String(stage)}`;
  }
}
